import { Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatMenu } from '@angular/material/menu';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { NotificationService } from './notification.service';
import { NotificationAppType } from '../../../../../shared/enum/authorize';
import { ModalComponent } from '../../../../../shared/widgets/modal/modal.component';
import { environment } from '../../../../../environments/environment';
import { ComponentService } from '../../../../../shared/abstract/component.service';
import { RequestService } from '../../../../../shared/services/request.service';
import { FileManagerService } from '../../../../../shared/services/file-manager.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css'
})
export class NotificationsComponent extends ComponentService<any> implements OnDestroy, OnInit {
  @ViewChild("menu") menu!: MatMenu;
  subscription!: Subscription;
  notificationBadge!: number;
  notificationEnum = NotificationAppType;
  isMenuClosed = false;
  notifactionList: any[] = [];
  notificationCounterIn = 0;
  baseUrl = environment.apiUrl;

  //responseNotific;
  control: boolean = true;
  notifSub!: Subscription;
  //routerLinkDesc;
  constructor(
    injector: Injector,
    private _dialog: MatDialog,
    private _notifService: NotificationService,
    //private _service: Client,
    private _bottomSheet: MatBottomSheet,
    private _request: RequestService,
    private _router: Router,
    private fileManager: FileManagerService
  ) {
    super(injector);
    const source = interval(15000);
    this.subscription = source.subscribe(val => {
      if (this.control) {
        this.getNotificationsBadge().then(res => {
          res != undefined ? this.control = true : this.control = false;
        })
      }
    });
  }


  async getNotificationsBadge() {
    return await this._request.getNotificationsCount().then(async data => {

      return this.notificationBadge = data;
    })
  }

  ngOnInit() {

    this._notifService.getNotifications().then(_ => {
      if (_) {
        this.notifactionList = _;
      }
    })
    

  }

  ngOnDestroy() {
    
  }

  toggleBadgeNotifications() {
    this._request.getNotifications().then(data => {
      if(data)
      this.notifactionList = data;
    })
    this.notificationBadge = 0;
    this._appsService.logInfo("Bildirimler görüntülendi");
  }



  getRouter(notif): any {
    //var url = this.getUrl(notif);
    if (notif.notificationTypeId.toString() == NotificationAppType.CalculateTsp.toString() || notif.notificationTypeId.toString() == NotificationAppType.CalculateTsp.toString()) {
      //Open popup
      const dialogRef = this._dialog.open(ModalComponent, {
        data: {
          type: 'tspMessage',
          title: 'calculationResult',
          cancel: 'cancel',
          ok: 'confirm',
          color: 'warn',
          data: notif.body
        }
      });
    }
    else if (notif.notificationTypeId.toString() == NotificationAppType.ExcelImportType.toString() || notif.notificationTypeId.toString() == NotificationAppType.Report.toString()) {

      if (notif.fileId) {
        try {
          let suggestedName: string | undefined = undefined;
          if (notif.body) {
            const match = notif.body.match(/[^\/\\]+$/);
            if (match) {
              suggestedName = match[0];
            }
          }

          this.fileManager.downloadFileById(notif.fileId, suggestedName);


          if (notif.notificationTypeId.toString() == NotificationAppType.ExcelImportType.toString()) {
            const dialogRef = this._dialog.open(ModalComponent, {
              panelClass: 'dialog-responsive',
              maxWidth: '100vw',
              data: {
                type: 'bulk-import-result',
                title: 'excelImportResult',
                cancel: 'cancel',
                ok: 'confirm',
                color: 'warn',
                data: notif.body
              }
            });
          }
        } catch (error) {
          this.MessageBox(this.languageKey('chat.fileDownloadFailed') || 'Dosya indirilemedi', 'warn', 'center');
        }
      } else {
        const isValidExcelEndpoint = /^Resources[\\/]{1}ExcelImports[\\/]{1}.+\.xlsx$/i.test(notif.body);
        const isValidExcelEndpointWithReportPath = /^Resources[\\/]{1}Reports[\\/]{1}.+\.xlsx$/i.test(notif.body);
        const isValidPdfEndpointWithReportPath = /^Resources[\\/]{1}Reports[\\/]{1}.+\.pdf$/i.test(notif.body);

        if (isValidExcelEndpoint) {
          window.location.href = this.baseUrl + '/' + notif.body;

          const dialogRef = this._dialog.open(ModalComponent, {
            panelClass: 'dialog-responsive',
            maxWidth: '100vw',
            data: {
              type: 'bulk-import-result',
              title: 'excelImportResult',
              cancel: 'cancel',
              ok: 'confirm',
              color: 'warn',
              data: notif.body
            }
          });
        } else if (isValidExcelEndpointWithReportPath) {
          window.location.href = this.baseUrl + '/' + notif.body;

        } else if (isValidPdfEndpointWithReportPath) {
          window.open(this.baseUrl + '/' + notif.body, '_blank');
        }
      }



    }
    else {
      /*this._router.navigate(['app/' + url]);*/
    } 
    this._appsService.logInfo("Bildirim detayı görüntülendi");
  }


  showAllNotifications() {

    const dialogRef = this._dialog.open(ModalComponent, {
      data: {
        type: 'show-notifications',
        title: 'notifications',
        cancel: 'cancel',
        ok: 'confirm',
        color: 'warn',
        data: this.notifactionList
      }
    });



  }

  onMouseEnter(event: Event): void {
    const target = event.target as HTMLElement;
    target.style.backgroundColor = '#00A1FF'; // Blue background
    target.style.color = 'white';           // White text color
  }

  onMouseLeave(event: Event): void {
    const target = event.target as HTMLElement;
    target.style.backgroundColor = '#FFFFFF'; // Revert to white background
    target.style.color = '#777777';           // Revert to black text color
  }



  getUrl(notif): any {
    switch (notif.notificationTypeId.toString()) {
      case NotificationAppType.NotesType.toString():
        return 'notes/notes-management';
      case NotificationAppType.MailType.toString():
        return 'notices/notices-list';
      case NotificationAppType.ChartType.toString():
        return 'dashboard';
      case NotificationAppType.Report.toString() && notif.body != null:
        window.open(this.baseUrl + '/' + notif.body, '_blank');
        return 'report';
      case NotificationAppType.ExcelImportType.toString():
        //window.location.href = this.baseUrl + '/' + notif.body;
        return 'work-force';

      default:
        return '';
    }
  }

}
